/**
 * Created by andrey on 10.12.2025
 */

const OpenedGrounds = function (slot) {
    this.slot = slot;

    this.opened = new Map();

    this.save = cleverapps.accumulate(0, () => this._save());
};

OpenedGrounds.prototype.load = function () {
    let data = this.slot.load("opened");

    if (data === undefined) {
        return;
    }

    data = data || "";

    const numbers = UnitPacker.expandCoordinates(data);

    const decodeRLE = (rlePairs) => {
        const xs = [];
        let x = 0;

        for (let i = 0; i < rlePairs.length; i += 2) {
            const dx = rlePairs[i];
            const runLength = rlePairs[i + 1];

            x += dx;

            for (let k = 0; k < runLength; k++) {
                xs.push(x + k);
            }

            x = xs[xs.length - 1];
        }

        return xs;
    };

    let index = 0;

    while (index < data.length) {
        const y = numbers[index];
        const count = numbers[index + 1];

        const xs = decodeRLE(numbers.slice(index + 2, index + 2 + count));

        for (const x of xs) {
            this.add(x, y, true);
        }

        index += 2 + count;
    }
};

OpenedGrounds.prototype._save = function () {
    const numbers = [];

    const encodeRLE = (xsSorted) => {
        const res = [];

        let prevX = 0;
        let i = 0;

        while (i < xsSorted.length) {
            const startX = xsSorted[i];

            let runLength = 1;
            while (i + runLength < xsSorted.length && xsSorted[i + runLength] === startX + runLength) {
                runLength++;
            }

            res.push(startX - prevX, runLength);

            prevX = startX + runLength - 1;
            i += runLength;
        }

        return res;
    };

    for (const [y, xsSet] of this.opened.entries()) {
        const xsSorted = Array.from(xsSet).sort((a, b) => a - b);

        const rle = encodeRLE(xsSorted);

        numbers.push(y, rle.length, ...rle);
    }

    const data = UnitPacker.compactCoordinates(numbers);

    this.slot.save("opened", data);
};

OpenedGrounds.prototype.update = function () {
    const map = Map2d.currentMap;

    for (let y = 0; y < map.getHeight(); y++) {
        for (let x = 0; x < map.getWidth(); x++) {
            if (map.isGround(x, y) && !map.getFog(x, y)) {
                this.add(x, y);
            }
        }
    }
};

OpenedGrounds.prototype.add = function (x, y, fromLoad) {
    let xs = this.opened.get(y);
    if (!xs) {
        xs = new Set();
        this.opened.set(y, xs);
    }

    if (xs.has(x)) {
        return;
    }

    xs.add(x);

    if (!fromLoad) {
        this.save();
    }
};

OpenedGrounds.prototype.remove = function (x, y) {
    const xs = this.opened.get(y);
    if (!xs || !xs.has(x)) {
        return;
    }

    xs.delete(x);

    if (xs.size === 0) {
        this.opened.delete(y);
    }

    this.save();
};

OpenedGrounds.prototype.has = function (x, y) {
    const xs = this.opened.get(y);
    return xs && xs.has(x);
};

OpenedGrounds.prototype.isEmpty = function () {
    return this.opened.size === 0;
};

OpenedGrounds.prototype.listCells = function () {
    const cells = [];

    for (const [y, xs] of this.opened.entries()) {
        for (const x of xs) {
            cells.push(cc.p(x, y));
        }
    }

    return cells;
};